import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { FieldSetBox } from "../fieldSetBox";
import { formatCurrencyField, getStringOrDefault } from "../../utils/utils";
import { ReportField } from "./reportField";
import { observer } from "mobx-react";

const useStyles = makeStyles(() => ({
  longTextTypography: {
    fontSize: "14px",
    padding: "16px",
    paddingTop: "10px",
    fontWeight: 400,
  },
}));

interface ValueReconciliationBoxProps {
  valuationValues: any;
}

export const ValueReconciliationBox = observer(({ valuationValues }: ValueReconciliationBoxProps) => {
  const classes = useStyles();

  return (<FieldSetBox title="Value Reconciliation">
    <Grid container>
      <Grid item xs={4}>
        <ReportField
          label="As-Repaired Value"
          value={formatCurrencyField(valuationValues.asRepairedValue)}
        />
      </Grid>
      <Grid item xs={4}>
        <ReportField
          label="As-Is Value"
          value={formatCurrencyField(valuationValues.asIsValue)}
        />
      </Grid>
      <Grid item xs={4}>
        <ReportField
          label="Site Value"
          value={formatCurrencyField(valuationValues.siteValue)}
          removeRightBorder
        />
      </Grid>
      <Grid item xs={12}>
        <ReportField
          label="Value Reconciliation Comments"
          removeRightBorder
        >
          <Typography className={classes.longTextTypography}>
            {getStringOrDefault(valuationValues.valueReconciliationComments)}
          </Typography>
        </ReportField>
      </Grid>
    </Grid>
  </FieldSetBox>);
});